module.exports = __webpack_public_path__ + "img/about0.62d276d0.png";